import React, { useEffect, useState } from "react";
import ResponsiveDataManagement from "../../Components/Common/ResponsiveManagementLayout";
import SupplierService from "../../services/OrderingServices/SupplierService";
import { useNavigate } from "react-router-dom";
import { Card, CardBody, Badge } from "reactstrap";

const SupplierPending = () => {
  const [supplierPendingList, setSupplierPendingList] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const fetchPendingSuppliers = async () => {
    try {
      setLoading(true);
      const response = await SupplierService.getAllSuppliersPending();
      setSupplierPendingList(response || []);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPendingSuppliers();
  }, []);

  const handlePaginationChange = ({ page, perPage }) => {
    setCurrentPage(page);
    setPageSize(perPage);
  };

  const columns = [
    {
      name: "S.N",
      selector: (row, index) => (currentPage - 1) * pageSize + index + 1,
      width: "75px",
    },
    {
      name: "Supplier Name",
      selector: (row) => row.supplierName,
      sortable: true,
      cell: (row) => (
        <span
          style={{ cursor: "pointer", color: "#0d6efd" }}
          className="fw-medium"
          onClick={() => navigate(`/suppliers/detail/${row.supplierId}`)}
        >
          {row.supplierName}
        </span>
      ),
    },
    {
      name: "Phone",
      selector: (row) => row.supplierPhone,
      sortable: true,
    },
    {
      name: "Address",
      selector: (row) => row.supplierAddress,
      sortable: true,
      cell: (row) => (
        <span className="text-truncate" title={row.supplierAddress}>
          {row.supplierAddress}
        </span>
      ),
    },
    {
      name: "Total Bill",
      selector: (row) => row.totalBillAmount,
      sortable: true,
      right: true,
      cell: (row) => row.totalBillAmount?.toLocaleString() || 0,
    },
    {
      name: "Total Paid",
      selector: (row) => row.totalPaidAmount,
      sortable: true,
      right: true,
      cell: (row) => row.totalPaidAmount?.toLocaleString() || 0,
    },
    {
      name: "Total Return",
      selector: (row) => row.totalReturnAmount,
      sortable: true,
      right: true,
      cell: (row) => row.totalReturnAmount?.toLocaleString() || 0,
    },
    {
      name: "Balance",
      selector: (row) => row.outstandingBalance,
      sortable: true,
      right: true,
      cell: (row) => (
        <span className="fw-bold text-danger">
          {row.outstandingBalance?.toLocaleString() || 0}
        </span>
      ),
    },
    {
      name: "Unpaid Purchases",
      selector: (row) => row.unpaidPurchaseCount,
      sortable: true,
      center: true,
      cell: (row) => (
        <span className="badge bg-warning">
    {row.unpaidPurchaseCount}
  </span>
      ),
    },
    {
      name: "Action",
      cell: (row) => (
        <button
          className="btn btn-sm btn-soft-primary"
          onClick={() =>
            navigate("/suppliers/payment", {
              state: { supplierId: row.supplierId },
            })
          }
        >
          <i className="ri-money-dollar-circle-line me-1"></i> Pay
        </button>
      ),
      width: "100px",
    },
  ];

  return (
    <ResponsiveDataManagement
      title="Supplier Pending Payments"
      pageTitle="Finance"
      mobileCardTitle="Pending Payments"
      data={supplierPendingList}
      columns={columns}
      searchKeys={["supplierName", "supplierPhone", "supplierAddress"]}
      loading={loading}
      totalRows={0} // Client-side pagination
      currentPage={currentPage}
      pageSize={pageSize}
      onPaginationChange={handlePaginationChange}
      mobileCardRenderer={(item) => (
        <Card className="shadow-sm rounded-3 border-0 border-start border-4 border-danger mb-3">
          <CardBody className="p-3">
            <div className="d-flex justify-content-between align-items-start mb-2">
              <h6 className="fw-bold text-primary mb-0">{item.supplierName}</h6>
              <Badge color="danger">
                {item.outstandingBalance?.toLocaleString() || 0}
              </Badge>
            </div>
            <p className="text-muted mb-1 small">
              <i className="ri-phone-line me-1"></i>
              {item.supplierPhone}
            </p>
            <p className="text-muted mb-2 small">
              <i className="ri-map-pin-line me-1"></i>
              {item.supplierAddress}
            </p>
            <div className="d-flex justify-content-between pt-2 border-top">
              <div className="text-center">
                <div className="text-muted small">Bill</div>
                <div className="fw-bold">
                  {item.totalBillAmount?.toLocaleString() || 0}
                </div>
              </div>
              <div className="text-center">
                <div className="text-muted small">Paid</div>
                <div className="fw-bold">
                  {item.totalPaidAmount?.toLocaleString() || 0}
                </div>
              </div>
              <div className="text-center">
  <div className="small">Unpaid</div>
  <span className="badge bg-warning">
    {item.unpaidPurchaseCount}
  </span>
</div>
            </div>
            <div className="mt-3">
              <button
                className="btn btn-sm btn-primary w-100"
                onClick={() =>
                  navigate("/suppliers/payment", {
                    state: { supplierId: item.supplierId },
                  })
                }
              >
                <i className="ri-money-dollar-circle-line me-1"></i> Make Payment
              </button>
            </div>
          </CardBody>
        </Card>
      )}
    />
  );
};

export default SupplierPending;
